export const INCOME_STRUCTURE_BY_KVED_TABLE_ARIA_LABEL = 'Структура доходів за КВЕД';
export const INCOME_STRUCTURE_BY_KVED_TABLE_HEADERS = [
  '№',
  'Код за КВЕД 2010',
  'Групи видів економічної діяльності',
  'Сума доходу, тис. грн.',
] as const;
export const INCOME_STRUCTURE_BY_KVED_TABLE_COLUMN_WIDTHS = ['7%', '18%', '50%', '25%'] as const;
export const INCOME_STRUCTURE_BY_KVED_TABLE_MIN_WIDTH = 900;
export const INCOME_STRUCTURE_BY_KVED_GROUP_SEPARATOR = ' — ';
